export interface Changelog {
  version: string;
  date: string;
  summary: string;
}

export const changelogs: Changelog[] = [
  { version: '0.9.0', date: '2026-02-22', summary: 'データエクスポート機能追加（JSON / CSV / Markdown）' },
  { version: '0.8.0', date: '2026-02-21', summary: '初回チュートリアル追加、エントリに画像添付（プレミアム）、過去日付に時刻指定' },
  { version: '0.7.0', date: '2026-02-20', summary: 'サイドバー修正、感情スコアのレンジスライダー、カレンダーに感情カラードット追加' },
  { version: '0.6.0', date: '2026-02-20', summary: '振り返りUI改善：フォーム折りたたみ、スワイプ削除、X共有、つながりリンク' },
  { version: '0.5.0', date: '2026-02-20', summary: '振り返りアルバムが2ページに凝縮。隠れたつながりにAIが理由を説明' },
  { version: '0.4.0', date: '2026-02-19', summary: '辞書が進化！誤変換を「A→B」ルールで即修正。録音中もリアルタイム補正' },
  { version: '0.3.0', date: '2026-02-19', summary: '更新情報 & 改善要望フォーム追加' },
  { version: '0.2.0', date: '2026-02-18', summary: 'モバイルUI改善 & OGPデザイン刷新' },
  { version: '0.1.0', date: '2026-02-15', summary: '振り返りアルバム・ワードクラウド追加' },
];

export const CURRENT_VERSION = changelogs[0].version;
